import {FieldErrors} from "react-hook-form";

interface ICollectLeadFormFieldErrorPathsResult {
    errorFields: string[];
    errorMessages: string[];
}

export const collectLeadFormFieldErrorPaths = (errors: FieldErrors, prefix = ""): ICollectLeadFormFieldErrorPathsResult => {
    const errorFields: string[] = [];
    const errorMessages: string[] = [];

    for (const key of Object.keys(errors)) {
        const fieldError = errors[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (!fieldError || typeof fieldError !== "object") {
            continue;
        }

        if ("message" in fieldError && typeof fieldError.message === "string" && fieldError.message) {
            errorFields.push(path);
            errorMessages.push(fieldError.message);
            continue;
        }

        const nested = collectLeadFormFieldErrorPaths(fieldError as FieldErrors, path);
        errorFields.push(...nested.errorFields);
        errorMessages.push(...nested.errorMessages);
    }

    return {errorFields, errorMessages};
};
import {FieldErrors} from "react-hook-form";

interface ICollectLeadFormFieldErrorPathsResult {
    errorFields: string[];
    errorMessages: string[];
}

export const collectLeadFormFieldErrorPaths = (errors: FieldErrors, prefix = ""): ICollectLeadFormFieldErrorPathsResult => {
    const errorFields: string[] = [];
    const errorMessages: string[] = [];

    for (const key of Object.keys(errors)) {
        const fieldError = errors[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (!fieldError || typeof fieldError !== "object") {
            continue;
        }

        if ("message" in fieldError && typeof fieldError.message === "string" && fieldError.message) {
            errorFields.push(path);
            errorMessages.push(fieldError.message);
            continue;
        }

        const nested = collectLeadFormFieldErrorPaths(fieldError as FieldErrors, path);
        errorFields.push(...nested.errorFields);
        errorMessages.push(...nested.errorMessages);
    }

    return {errorFields, errorMessages};
};
